import React, { useEffect, useRef, useState } from "react";
import Pagination from "../../Components/Pagination/Pagination.jsx";
import "../Users/style.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";
import "jspdf-autotable";
import "sweetalert2/dist/sweetalert2.min.css";
import { getAccommodationsMap, getTenant, tenantStatusUpdate, updateCustomerStatus } from "../../utils/api.js";
import { clone, isEmpty, pdfData } from "../../utils/common.js";
import LocalLoader from "../../Components/Loader/LocalLoader.js";
import { FilterWrapper } from "../../assets/styles/FilterStyle.js";

import animationData1 from "../../assets/lotties/question.json";
import { TableWrapper } from "../../Components/styledConstant.js";
import { useSelector } from "react-redux";
import { AlertWrapper } from "../../Components/Modal/style.js";
import ConfirmBox from "../../Components/ConfirmBox/ConfirmBox.jsx";

import MoreOptions from "../../Components/MoreOptions/MoreOptions.jsx";
import TenantKyc from "./TenantKyc.jsx";
import TenantKycDetails from "../B2CUsers/TenantKycDetails.jsx";
import AutoSuggestion from "../../Components/AutoSuggest/AutoSuggest.js";

require("react-datepicker/dist/react-datepicker.css");

const RentalManager = () => {
  const [apiData, setApiData] = useState([]);

  const [totalPages, setTotalPages] = useState(null);
  const [totalElements, setTotalElements] = useState("");
  const [currPage, setCurrPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pdfData_, setPdfData] = useState([]);
  const [downloadLoader, setDownloadLoader] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({});
  const [mobileNumber, setMobileNumber] = useState("");
  const [status, setStatus] = useState("");
  const [userData, setUserData] = useState("");

  const [updateStatus, setUpdateStatus] = useState({});
  const [loginUserType, setLoginUserTye] = useState("");
  const [showfilter, setShowFilter] = useState("");
  const [accommodations, setAccommodations] = useState([]);
  const [filterAcc, setfilterAcc] = useState([]);
  const [showSuggestion,setShowSuggestion] = useState(false);
  const [accommodationId,setAccommodationId] = useState(undefined);
  const [searchTerm,setSearchTerm] = useState("")

  const navigate = useNavigate();

  const link = useRef();




  const location = useLocation();
  const { mobileNumber:number } = location.state || {};

  useEffect(() => {
    if (number) {
      setUserData(number);
      navigate(location.pathname, { replace: true });
    }
  }, [number]);

  const handleApiData = async (key, params) => {

    if (key === "CSV") {
      setDownloadLoader("CSV");
    } else if (key === "PDF") {
      setDownloadLoader("PDF");
    } else {
      setDownloadLoader("");
      setLoading(true);
    }

  

    getTenant(10,params?.pageNo,params?.mobileNumber,params?.accommodationId).then((resp) => {
      setLoading(false);
      setDownloadLoader("");
     

      if (resp?.data?.data) {
        if (key === "CSV") {
          setPdfData(resp?.data?.data?.content);

          setTimeout(() => {
            const csvlink = link.current;
            csvlink.link.click();
          }, 100);
        } else if (key === "PDF") {
          userlistPdfData(resp?.data?.data?.content);
        } else {
         console.log("apiData",resp?.data?.data?.content)
          setCurrPage(params?.pageNo);
          setApiData(resp?.data?.data?.content);
          setTotalPages(resp?.data?.data?.totalPages);
          setTotalElements(resp?.data?.data?.totalElements);
        }
      }
    });
  };


    const handleGetAccommodations = async () => {
   
    getAccommodationsMap(0).then((resp) => {
      setLoading(false);
    
  console.log("accommodations",resp)
      if (resp?.data.message === "SUCCESS") {
      
          setAccommodations(resp?.data?.data || []); 
          setfilterAcc(resp?.data?.data || []); 
        
      }
    });
  };

  useEffect(() => {
    const params = {
      mobileNumber: "",
      status: "",
      pageNo: 0,
      accommodationId:undefined
    };

    handleApiData("", params);
       handleGetAccommodations();
  }, []);

  //API to Export PDF file

  const currentPage = (page) => {
    const params = {
      mobileNumber: mobileNumber,
      status: status,
      pageNo: page,
      accommodationId:accommodationId,
    };
    handleApiData("", params);
    setCurrPage(page);
  };

  const userlistPdfData = (data = []) => {

   
    const tableHeader = [
      {
     
        tenantName: "Tenant Name",
        mobileNumber: "Mobile Number",
        isAadhaarVerified: "Aadhar Verification",
        isAdvanceKycVerified: "Kyc Verification",
        isMobileRegistered: "Mobile Registered",
        isDocVerified: "Document Verification",
        status: "Status",
      },
    ];

    pdfData(data, tableHeader, "B2C-User-List", 400);
  };

  const { user } = useSelector((state) => state.user);
  const autoSuggestionRef = useRef(null);

  useEffect(() => {
    if (loginUserType === "" && !isEmpty(user?.userType)) {
      setLoginUserTye(user?.userType);
    }
  }, [user]);




  useEffect(() => {
    if (isEmpty(message)) return;
    const timerId = setTimeout(() => {
      setMessage({});
    }, 5000);

    return () => {
      clearTimeout(timerId);
    };
  }, [message]);

 

  const search = () => {
   
    handleApiData("", {
      mobileNumber: mobileNumber,
      status: status,
      accommodationId:accommodationId,
      pageNo: 0,
    });

    setCurrPage(0);
  };

  const refresh = () => {
    handleApiData("", {
      mobileNumber: "",
      status: "",
      pageNo: 0,
      accommodationId:undefined,
    });

    setMobileNumber("");
    setStatus("");
    setCurrPage(0);
    setAccommodationId(undefined)
    setSearchTerm("")
  };
  const moreOptions = [
    {
      label: (item) => (item?.status === "ACTIVE" ? "INACTIVE" : "ACTIVE"),
      click: (item) => setUpdateStatus(item),
      show: (item) => item?.status === "ACTIVE",
    },
    {
      label: "Tenant KYC",
      click: (item) => setUserData(item?.mobileNumber),
      show: () => true,
    },
  ];
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        autoSuggestionRef.current &&
        !autoSuggestionRef.current.contains(event.target)
      ) {
        setShowSuggestion(false); 
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleChange = (item) =>{
      setAccommodationId(item?.id);
      setShowSuggestion(false);
      setSearchTerm(item?.name);
  }
  
  const handleInputChange = (e) =>{
                     setAccommodationId(undefined);
                      setSearchTerm(e.target.value);
          
                
             const filterData =  filterByNameOrAddress(accommodations,e.target.value);
              setfilterAcc([...filterData])
  }

  const randerIdem = (item,index) =>{
    
    return(
        <li key={index} onClick={() =>handleChange(item)}>
                <div className="flex justify-between pd-10-0">
                  <div className="flex gap-15 items-center">
                   
                    <div className="flex column gap-5">
                      <span className="fs-13 fw-500 cursor">{item?.name}</span>
                      <label className="fs-10 fw-400 cursor color_grey">
                        {item?.address}
                      </label>
                    </div>
                  </div>
                  <div className="flex gap-10 items-center cursor">
                    <span className="fs-12 fw-600">{location?.code}</span>
                  </div>
                </div>
              </li>
    )
  }

  function filterByNameOrAddress(list, searchText) {
  if (!searchText) return list;

  const query = searchText.toLowerCase();

 

  return list.filter(item =>
    item.name.toLowerCase().includes(query) ||
    item.address.toLowerCase().includes(query)
  );
}


  const updateUserStatus = (item) => {

  setLoading(true);
    tenantStatusUpdate(item?.tenantUuid, "INACTIVE").then((res) => {
       setLoading(false);
        if (res?.data?.message === "SUCCESS") {
          setMessage({ type: "success", msg: `Tenant inactive successfully` });
          setUpdateStatus({});
            handleApiData("", {
      mobileNumber: mobileNumber,
      status: status,
      accommodationId:accommodationId,
      pageNo: currPage,
    });
       
        } else {
          const errorMsg = res?.data?.errorCodeList?.length
            ? res?.data?.errorCodeList.join(", ")
            : res?.data?.msg;
          setMessage({
            type: "error",
            msg: errorMsg || "Error approving Tenant",
          });
        }
      })
      .catch((err) => {
        setMessage({
          type: "error",
          msg: `Error approving Tenant: ${
            err?.response?.data?.message || err.message
          }`,
        });
      })
      .finally(() => {
       
      });
  };
  return ( 
    <>
       { !isEmpty(userData) &&  <TenantKycDetails userName={userData}  close={()=>setUserData("")}/>}

      {!isEmpty(message) && (
        <AlertWrapper className={`${message.type} globle`}>
          <span className="close" onClick={() => setMessage({})}>
            ×
          </span>
          {message.msg}
        </AlertWrapper>
      )}
      <div className="userlisthead_container">
        <div style={{ padding: "30px" }}>
          <div className="transaction_main_container">
            <div className="userlist_head">
              <div className="userlist_heading">
                <div className="userlist_left">
                  <label>Tenant List</label>
                </div>
                <div className="userlist_right">
                  {downloadLoader !== "PDF" ? (
                    <button
                      className="pdf"
                      onClick={(e) =>
                        handleApiData("PDF", {
                          mobileNumber: mobileNumber,
                          status: status,
                          pageNo: 0,
                        })
                      }
                    >
                      PDF
                    </button>
                  ) : (
                    <button className="pdf">
                      <div className="btn-loader">
                        <i className="fa-solid fa-spinner"></i>
                      </div>
                    </button>
                  )}
                  {downloadLoader !== "CSV" ? (
                    <button
                      className="xls"
                      onClick={(e) =>
                        handleApiData("CSV", {
                          mobileNumber: mobileNumber,
                          status: status,
                          pageNo: 0,
                        })
                      }
                    >
                      CSV
                    </button>
                  ) : (
                    <button className="xls">
                      <div className="btn-loader">
                        <i className="fa-solid fa-spinner"></i>
                      </div>
                    </button>
                  )}
                  <CSVLink
                    ref={link}
                    data={pdfData_}
                    filename="B2C-User-List.csv"
                  ></CSVLink>
                </div>
                <div className="userlist_filter">
                  <button
                    className="filter fs-16"
                    onClick={(e) =>
                      showfilter === "active"
                        ? setShowFilter("")
                        : setShowFilter("active")
                    }
                  >
                    <i className="fa-solid fa-filter"></i>
                  </button>
                </div>
              </div>
            </div>
            <FilterWrapper
              style={{ height: "auto" }}
              className={`display_data ${showfilter}`}
            >
              <div className="grow-0">
                <div className="grow-1">
                  <div className="flex align-items gap-15">
                     <div style={{position:"relative"}} ref={autoSuggestionRef}>
                    <input
                      type="text"
                      name="accommodations"
                      placeholder="Search Accommodation"
                     value={searchTerm}
                     onFocus={()=>setShowSuggestion(true)}
                     onChange={handleInputChange}
                    
                    
                    />
                    {showSuggestion && (
              <div >
                 <AutoSuggestion
    fromCityList={filterAcc || []}
    setCityName={(name) =>{}}
    setCityId={(id) =>{}}
   
    setShowCity={()=>{}}
    showCity={{ fromCityShow: true }}
    cityNameKey="cityName"
    inputElement={null}
    randerItem={randerIdem}
  />
              
              </div>
)}
                  </div>

                 

                    <div className="input-field">
                      <div className="flex">
                        <input
                          type="text"
                          placeholder="Enter Mobile Number"
                          value={mobileNumber}
                          onChange={(e) => setMobileNumber(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className=" ">
                      <button
                        className="userlist_btn"
                        onClick={search}
                        style={{ width: "100px" }}
                      >
                        Search
                      </button>
                    </div>
                    <div className="button">
                      <button
                        className="refresh-btn"
                        style={{ width: "60px" }}
                        onClick={refresh}
                      >
                        <i className="fa fa-refresh"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </FilterWrapper>
          </div>

          {apiData && (
            <div className="table-loader">
              {loading && <LocalLoader className="tableLoader" />}
              <TableWrapper className="table-card-wrapper">
                <table className="table">
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>Tenant Name</th>
                      <th>Mobile Number</th>
                      <th>Aadhar Verification</th>
                      <th>Adv. Kyc Verification</th>
                      <th>Mobile Registered</th>
                      <th>Document verification</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {apiData &&
                      apiData?.map((item, index) => {
                        const name = item?.firstName + " " + item?.lastName;
                        return (
                          <tr key={item.transactionId}>
                            <td className="td-none">
                              <span className="card-th">Sr No</span>
                              <span>{currPage * pageSize + index + 1}</span>
                            </td>

                            <td>
                              <span className="card-th">Tenant Name</span>
                              <span>{item?.tenantName || "-"}</span>
                            </td>

                            <td>
                              <span className="card-th">Mobile Number</span>
                              <span>{item?.mobileNumber || "-"}</span>
                            </td>

                            <td>
                              <span className="card-th">
                                Aadhar Verification
                              </span>
                              <span
                                style={{
                                  color: item?.isAadhaarVerified
                                    ? "green"
                                    : "red",
                                  fontWeight: "bold",
                                }}
                              >
                                {item?.isAadhaarVerified === true ? "Verified" : "Not Verified"}
                              </span>
                            </td>
                            <td>
                              <span className="card-th">Kyc Verification</span>
                              <span style={{
                                  color: item?.isAdvanceKycVerified
                                    ? "green"
                                    : "red",
                                  fontWeight: "bold",
                                }}>{item?.isAdvanceKycVerified=== true ?"Verified": "Not Verified"}</span>
                            </td>
                            <td>
                              <span className="card-th">Mobile Registered</span>
                              <span style={{
                                  color: item?.isMobileRegistered
                                    ? "green"
                                    : "red",
                                  fontWeight: "bold",
                                }}>{item?.isMobileRegistered === true ?"Verified":"Not Verified"}</span>
                            </td>
                            <td>
                              <span className="card-th">
                                Document Verification
                              </span>
                              <span style={{
                                  color: item?.isDocVerified
                                    ? "green"
                                    : "red",
                                  fontWeight: "bold",
                                }}>{item?.isDocVerified === true ? "Verified":"Not Verified" }</span>
                            </td>
                            <td>
                              <span className="card-th">Status</span>
                              <span>
                                <div
                                  className={`${
                                    item.status == "ACTIVE"
                                      ? "active_status"
                                      : 
                                       item.status == "PENDING"?"pending_status"
                                       :
                                      "inactive_status"
                                  }`}
                                >
                                  {item?.status}
                                </div>
                              </span>
                            </td>

                            <td className="user_action_btn">
                              <span className="card-th">Actions</span>
                              <MoreOptions options={moreOptions} items={item} />
                             
                            </td>
                          </tr>
                        );
                      })}

                    {!loading && apiData && apiData.length < 1 && (
                      <tr>
                        <td
                          colSpan={6}
                          style={{ textAlign: "center", color: "red" }}
                        >
                          No data found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </TableWrapper>
            </div>
          )}

          {totalPages > 1 && (
            <Pagination
              items={apiData}
              itemsPerPage={pageSize}
              setitemsPerPage={setPageSize}
              currentPage={currPage}
              setcurrentPage={(page) => currentPage(page)}
              totalPages={totalPages}
              forcePage={currPage}
            />
          )}
        </div>

        {!isEmpty(updateStatus) && (
          <ConfirmBox
            cancel={() => setUpdateStatus({})}
            ok={() => updateUserStatus(updateStatus)}
            isLoding={loading}
          >
            <label>
              You want to inactive this tenant?
            </label>
          </ConfirmBox>
        )}
      </div>
    </>
  );
};

export default RentalManager;
